import React from "react";

export default function InventoryManagement() {
  return (
    <div className="container text-center py-4 position-relative">
      <h2 className="title split-collab text-danger" style={{ fontWeight: "bold", fontSize: "35px" }}
      
      >
        INVENTORY MANAGEMENT
      </h2>
      <hr
        style={{
          width: "200px",
          borderTop: "2px solid black",
          margin: "20px auto",
        }}
      />

      {/* Desktop Circular Layout */}
      <div
        className="d-none d-md-block"
        style={{
          position: "relative",
          width: "100%",
          maxWidth: "850px",
          height: "500px",
          margin: "90px auto",
          borderRadius: "50%",
          padding: "20px",
        }}
      >
        {/* Center Image */}
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 1,
          }}
        >
          <img
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ24Ow1xRIPVAQPRHqG3FcXsh80DR0PSCgzqA&s"
            alt="Center Icon"
            style={{ width: "180px", height: "180px", borderRadius: "50%" }}
          />
        </div>

        {/* === Steps with transition added to text cards === */}
        {/* Step 1 */}
        <div
          style={{
            position: "absolute",
            top: "3%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div
            style={{
              backgroundColor: "#f15b80",
              color: "#fff",
              width: "90px",
              height: "90px",
              borderRadius: "50%",
              lineHeight: "90px",
              fontWeight: "bold",
              fontSize: "22px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              marginBottom: "15px",
            }}
          >
            01
          </div>
          <div
            style={{
              fontSize: "16px",
              fontWeight: "500",
              maxWidth: "250px",
              textAlign: "center",
              lineHeight: "1.4",
              border: "none",
              borderRadius: "8px",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
              padding: "5px 10px",
              color: "grey",
              transition: "box-shadow 0.3s ease, border 0.3s ease",
            }}
          >
            STOCK AVAILABILITY OF INVENTORY
          </div>
        </div>

        {/* Step 2 */}
        <div
          style={{
            position: "absolute",
            top: "15%",
            right: "2%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div
            style={{
              backgroundColor: "#f9b233",
              color: "#fff",
              width: "90px",
              height: "90px",
              borderRadius: "50%",
              lineHeight: "90px",
              fontWeight: "bold",
              fontSize: "22px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              marginBottom: "15px",
            }}
          >
            02
          </div>
          <div
            style={{
              fontSize: "16px",
              fontWeight: "500",
              maxWidth: "250px",
              textAlign: "center",
              lineHeight: "1.4",
              border: "none",
              borderRadius: "8px",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
              padding: "5px 10px",
              color: "grey",
              transition: "box-shadow 0.3s ease, border 0.3s ease",
            }}
          >
            PURCHASING & ORDERING OF SHORTFALL
          </div>
        </div>

        {/* Step 3 */}
        <div
          style={{
            position: "absolute",
            bottom: "15%",
            right: "2%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div
            style={{
              backgroundColor: "#8bc34a",
              color: "#fff",
              width: "90px",
              height: "90px",
              borderRadius: "50%",
              lineHeight: "90px",
              fontWeight: "bold",
              fontSize: "22px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              marginBottom: "15px",
            }}
          >
            03
          </div>
          <div
            style={{
              fontSize: "16px",
              fontWeight: "500",
              maxWidth: "250px",
              textAlign: "center",
              lineHeight: "1.4",
              border: "none",
              borderRadius: "8px",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
              padding: "5px 10px",
              color: "grey",
              transition: "box-shadow 0.3s ease, border 0.3s ease",
            }}
          >
            INSTALLING & TESTING OF REQUIRED OS
          </div>
        </div>

        {/* Step 4 */}
        <div
          style={{
            position: "absolute",
            bottom: 0,
            left: "50%",
            transform: "translate(-50%, 50%)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div
            style={{
              backgroundColor: "#f15b80",
              color: "#fff",
              width: "90px",
              height: "90px",
              borderRadius: "50%",
              lineHeight: "90px",
              fontWeight: "bold",
              fontSize: "22px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              marginBottom: "15px",
            }}
          >
            04
          </div>
          <div
            style={{
              fontSize: "16px",
              fontWeight: "500",
              maxWidth: "250px",
              textAlign: "center",
              lineHeight: "1.4",
              border: "none",
              borderRadius: "8px",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
              padding: "5px 10px",
              color: "grey",
              transition: "box-shadow 0.3s ease, border 0.3s ease",
            }}
          >
            TAGGING OF ASSET (LAPTOP/DESKTOP)
          </div>
        </div>

        {/* Step 5 */}
        <div
          style={{
            position: "absolute",
            bottom: "15%",
            left: "3%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div
            style={{
              backgroundColor: "#f9b233",
              color: "#fff",
              width: "90px",
              height: "90px",
              borderRadius: "50%",
              lineHeight: "90px",
              fontWeight: "bold",
              fontSize: "22px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              marginBottom: "15px",
            }}
          >
            05
          </div>
          <div
            style={{
              fontSize: "16px",
              fontWeight: "500",
              maxWidth: "250px",
              textAlign: "center",
              lineHeight: "1.4",
              border: "none",
              borderRadius: "8px",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
              padding: "5px 10px",
              color: "grey",
              transition: "box-shadow 0.3s ease, border 0.3s ease",
            }}
          >
            EXAM READINESS
          </div>
        </div>

        {/* Step 6 */}
        <div
          style={{
            position: "absolute",
            top: "12%",
            left: "3%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div
            style={{
              backgroundColor: "#8bc34a",
              color: "#fff",
              width: "90px",
              height: "90px",
              borderRadius: "50%",
              lineHeight: "90px",
              fontWeight: "bold",
              fontSize: "22px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              marginBottom: "15px",
            }}
          >
            06
          </div>
          <div
            style={{
              fontSize: "16px",
              fontWeight: "500",
              maxWidth: "250px",
              textAlign: "center",
              lineHeight: "1.4",
              border: "none",
              borderRadius: "8px",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
              padding: "5px 10px",
              color: "grey",
              transition: "box-shadow 0.3s ease, border 0.3s ease",
            }}
          >
            KIT BAG READINESS
          </div>
        </div>
      </div>

      {/* Mobile View remains untouched */}
      <div
        className="d-flex d-md-none flex-column align-items-center gap-4 mt-4 px-3"
        style={{ paddingBottom: "50px" }}
      >
        <StepMobile number="01" color="#f15b80" label="STOCK AVAILABILITY OF INVENTORY" />
        <StepMobile number="02" color="#f9b233" label="PURCHASING & ORDERING OF SHORTFALL" />
        <StepMobile number="03" color="#8bc34a" label="INSTALLING & TESTING OF REQUIRED OS" />
        <StepMobile number="04" color="#f15b80" label="TAGGING OF ASSET (LAPTOP/DESKTOP)" />
        <StepMobile number="05" color="#f9b233" label="EXAM READINESS" />
        <StepMobile number="06" color="#8bc34a" label="KIT BAG READINESS" />
      </div>
    </div>
  );
}

function StepMobile({ number, color, label }) {
  return (
    <div className="d-flex flex-column align-items-center">
      <div
        style={{
          backgroundColor: color,
          color: "#fff",
          width: "90px",
          height: "90px",
          borderRadius: "50%",
          lineHeight: "90px",
          fontWeight: "bold",
          fontSize: "22px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          marginBottom: "15px",
        }}
      >
        {number}
      </div>
      <div
        style={{
          fontSize: "18px",
          fontWeight: "600",
          maxWidth: "250px",
          textAlign: "center",
          lineHeight: "1.4",
          border: "1.5px solid black",
          borderRadius: "8px",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
          padding: "5px 10px",
          color: "grey",
        }}
      >
        {label}
      </div>
    </div>
  );
}
